import created from './attrs/created'
import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

import AgencyOrdersChart from './../Charts/Agency/Orders/Index'
import TopSellingTrips from './../Charts/Agency/TopSellingTrips/Index'
import LatestOrders from './../Charts/Agency/LatestOrders/Index'
import LatestReservations from './../Charts/Agency/LatestReservations/Index'
import AgencyReservationsChart from './../Charts/Agency/Reservations/Index'
import TopReservedTrips from './../Charts/Agency/TopReservedTrips/Index'
import SalesReport from './../Charts/Agency/SalesReport/Index'

export default {
    name: 'Dashboard',
    created,
    computed,
    data,
    methods,
    mounted,
    components: {
        AgencyOrdersChart,
        TopSellingTrips,
        LatestOrders,
        LatestReservations,
        AgencyReservationsChart,
        TopReservedTrips,
        SalesReport
    }
}
